export default "__VITE_ASSET__Df8ni1Zz__"